import React from 'react';
import Loadable from 'react-loadable'

function Loading() {
    return <div className="loading">

    </div>;
}
// Corporation
const Corporation = Loadable({
    loader: () => import('./Views/Establishment/ViewEstablishment/viewEstablishment'),
    loading: Loading,
});
const CorporationDetails = Loadable({
    loader: () => import('./Views/Establishment/EstablishmentDetails/EstablishmentDetails'),
    loading: Loading,
});

//Entertainement
const ViewEntertainement = Loadable({
    loader: () => import('./Views/Entertainement/ViewEntertainement/ViewEntertainement'),
    loading: Loading,
});
const AddEntertainement = Loadable({
    loader: () => import('./Views/Entertainement/AddEntertainement/AddEntertainement'),
    loading: Loading,
});
const EditEntertainement = Loadable({
    loader: () => import('./Views/Entertainement/EditEntertainement/EditEntertainement'),
    loading: Loading,
});
const EntertainementDetails = Loadable({
    loader: () => import('./Views/Entertainement/ViewDetailsEntertainement/ViewDetailsEntertainement'),
    loading: Loading,
});
// TOURISTICAL_MONUMENTS 
const TOURISTICAL_MONUMENTS = Loadable({
    loader: () => import('./Views/TOURISTICAL_MONUMENTS/ViewTOURISTICAL_MONUMENTS/ViewTOURISTICAL_MONUMENTS'),
    loading: Loading,
});
const TOURISTICAL_MONUMENTSDetails = Loadable({
    loader: () => import('./Views/TOURISTICAL_MONUMENTS/ViewDetailsTOURISTICAL_MONUMENTS/ViewDetailsShow'),
    loading: Loading,
});
const AddTOURISTICAL_MONUMENTS = Loadable({
    loader: () => import('./Views/TOURISTICAL_MONUMENTS/AddTOURISTICAL_MONUMENTS/AddTOURISTICAL_MONUMENTS'),
    loading: Loading,
});
const EditTOURISTICAL_MONUMENTS = Loadable({
    loader: () => import('./Views/TOURISTICAL_MONUMENTS/EditTOURISTICAL_MONUMENTS/EditTOURISTICAL_MONUMENTS'),
    loading: Loading,
});
// Dashboard
const Dashboard = Loadable({
    loader: () => import('./Views/DashBoard/Admin/dashBoard'),
    loading: Loading,
});

// Sharing app
const SharingDriverApp = Loadable({
    loader: () => import('./Views/DashBoard/Admin/ShareDriverApp'),
    loading: Loading
})
const SharingClientApp = Loadable({
    loader: () => import('./Views/DashBoard/Admin/ShareClientApp'),
    loading: Loading
})
// profile
const Profile = Loadable({
    loader: () => import('./Views/Profile/profile'),
    loading: Loading,
});
// Client
const Client = Loadable({
    loader: () => import('./Views/Clients/viewClient/viewclient'),
    loading: Loading,
});
const AddClient = Loadable({
    loader: () => import('./Views/Clients/AddClient/addclient'),
    loading: Loading,
});
const EditClient = Loadable({
    loader: () => import('./Views/Clients/EditClient/editclient'),
    loading: Loading,
});
const ViewDetailsClient = Loadable({
    loader: () => import('./Views/Clients/ViewDetailsClient/viewDetailsClient'),
    loading: Loading,
});

// Event
const ViewEvents = Loadable({
    loader: () => import('./Views/Events/Events/ViewEvent/ViewEvent'),
    loading: Loading,
});
const AddEvent = Loadable({
    loader: () => import('./Views/Events/Events/AddEvent/addEvent'),
    loading: Loading,
});
const EditEvent = Loadable({
    loader: () => import('./Views/Events/Events/EditEvent/EditEvent'),
    loading: Loading,
});
const ViewDetailsEvent = Loadable({
    loader: () => import('./Views/Events/Events/ViewEventDetails/ViewEventDetails'),
    loading: Loading,
});

// Cinema
const Cinema = Loadable({
    loader: () => import('./Views/Cinema/Cinema/ViewCinema/viewcinema'),
    loading: Loading,
});
const AddCinema = Loadable({
    loader: () => import('./Views/Cinema/Cinema/AddCinema/addcinema'),
    loading: Loading,
});
const EditCinema = Loadable({
    loader: () => import('./Views/Cinema/Cinema/EditCinema/editcinema'),
    loading: Loading,
});

const CinemaDetails = Loadable({
    loader: () => import('./Views/Cinema/Cinema/CinemaDetails/CinemaDetails'),
    loading: Loading,
});

// Film Type

const Type = Loadable({
    loader: () => import('./Views/FilmTypes/viewFilmType/viewfilmType'),
    loading: Loading,
});
const AddType = Loadable({
    loader: () => import('./Views/FilmTypes/AddFilmType/addfilmType'),
    loading: Loading,
});
const EditType = Loadable({
    loader: () => import('./Views/FilmTypes/EditFilmType/editfilm'),
    loading: Loading,
});
const ViewDetailsFilmTyps = Loadable({
    loader: () => import('./Views/FilmTypes/ViewFilmTypeDetails/viewDetailsFilm'),
    loading: Loading,
});

// Film
const Movies = Loadable({
    loader: () => import('./Views/Films/viewFilm/viewfilm'),
    loading: Loading,
});

const AddFilm = Loadable({
    loader: () => import('./Views/Films/AddFilm/addfilm'),
    loading: Loading,
});
const EditFilm = Loadable({
    loader: () => import('./Views/Films/EditFilm/editfilm'),
    loading: Loading,
});

const ViewDetailsFilm_admin = Loadable({
    loader: () => import('./Views/Films/ViewFilmDetails/viewDetailsFilm-admin'),
    loading: Loading,
});

// Sliders
const Slider = Loadable({
    loader: () => import('./Views/Sliders/viewSlider/viewslider'),
    loading: Loading,
});
const AddSlider = Loadable({
    loader: () => import('./Views/Sliders/AddSlider/addslider'),
    loading: Loading,
});
const EditSlider = Loadable({
    loader: () => import('./Views/Sliders/EditSlider/editslider'),
    loading: Loading,
});
// Sponser
const Sponser = Loadable({
    loader: () => import('./Views/sponsers/viewSponser/viewsponser'),
    loading: Loading,
});
const AddSponser = Loadable({
    loader: () => import('./Views/sponsers/AddSponsers/addsponser'),
    loading: Loading,
});
const EditSponser = Loadable({
    loader: () => import('./Views/sponsers/EditSponsers/editsponser'),
    loading: Loading,
});

// ReportFilteration

const ReportFilteration = Loadable({
    loader: () => import('./Views/Reports/reports'),
    loading: Loading,
});
const ReportCreation = Loadable({
    loader: () => import('./Modules/Reports/report_Create'),
    loading: Loading
})

// SubAdmin
const SubAdmin = Loadable({
    loader: () => import('./Views/SubAdmin/ViewSubAdmin/viewsubadmin'),
    loading: Loading,
});
const AddSubAdmin = Loadable({
    loader: () => import('./Views/SubAdmin/AddSubAdmin/AddSubAdmin'),
    loading: Loading,
});
const EditSubAdmin = Loadable({
    loader: () => import('./Views/SubAdmin/EditSubAdmin/EditSubAdmin'),
    loading: Loading,
});
const ViewDetailsSubAdmin = Loadable({
    loader: () => import('./Views/SubAdmin/ViewDetailsSubAdmin/viewdetailsSubAdmin'),
    loading: Loading,
});
const SubAdminRoles = Loadable({
    loader: () => import('./Views/SubAdmin/Roles/Roles'),
    loading: Loading,
});
// Notification
const Notification = Loadable({
    loader: () => import('./Views/Notification/ViewNotification/viewnotification'),
    loading: Loading,
});

const AddNotification = Loadable({
    loader: () => import('./Views/Notification/AddNotification/addnotification'),
    loading: Loading,
});
const NotificationsViewDetails = Loadable({
    loader: () => import('./Views/Notification/NotificationsViewDetails/NotificationsViewDetails'),
    loading: Loading,
});

const Loginpage = Loadable({
    loader: () => import('./Views/Auth/AdminLogin/AdminLogin'),
    loading: Loading,
});

//Talent-Type
const ViewTalenttype = Loadable({
    loader: () => import('./Views/Talent-Type/ViewTalent-Type/ViewTalent-type'),
    loading: Loading,
});
const AddTalenttype = Loadable({
    loader: () => import('./Views/Talent-Type/AddTalent-Type/AddTalent-Type'),
    loading: Loading,
});
const EditTalenttype = Loadable({
    loader: () => import('./Views/Talent-Type/EditTalent-Type/EditTalent-Type'),
    loading: Loading,
});


const ViewDetailsTalenttype = Loadable({
    loader: () => import('./Views/Talent-Type/ViewDetails-Talent-Type/viewDetails-category'),
    loading: Loading,
});

//talent order
const ViewTalentOrder = Loadable({
    loader: () => import('./Views/TalentOrders/ViewTalentOrders/ViewTalentOrders'),
    loading: Loading,
});
const ViewDetailsTalentOrder = Loadable({
    loader: () => import('./Views/TalentOrders/ViewDetailsTalentOrders/viewDetailsTalentOrders'),
    loading: Loading,
});
//Talents

const Talents = Loadable({
    loader: () => import('./Views/Talents/viewTalents/viewTalents'),
    loading: Loading,
});
const ViewDetailsTalent = Loadable({
    loader: () => import('./Views/Talents/ViewDetailsTalents/viewDetailsTalents'),
    loading: Loading,
});
const AddTalent = Loadable({
    loader: () => import('./Views/Talents/AddTalent/addtalent'),
    loading: Loading,
});
const EditTalent = Loadable({
    loader: () => import('./Views/Talents/EditTalent/EditTalent'),
    loading: Loading,
});
const ViewTalentWork = Loadable({
    loader: () => import('./Views/Talents/Work/ViewWork/ViewWork'),
    loading: Loading,
});
const AddTalentWork = Loadable({
    loader: () => import('./Views/Talents/Work/AddWork/AddWork'),
    loading: Loading,
});
const EditTalentWork = Loadable({
    loader: () => import('./Views/Talents/Work/EditWork/EditWork'),
    loading: Loading,
});
// TalentSection
const TalentSection = Loadable({
    loader: () => import('./Views/Talent-Section/talent-section'),
    loading: Loading,
});
//Category
const ViewCategory = Loadable({
    loader: () => import('./Views/Category/ViewCategory/ViewCategory'),
    loading: Loading,
});
const AddCategory = Loadable({
    loader: () => import('./Views/Category/AddCategory/AddCategory'),
    loading: Loading,
});
const EditCategory = Loadable({
    loader: () => import('./Views/Category/EditCategory/EditCategory'),
    loading: Loading,
});

const ViewDetailsCategory = Loadable({
    loader: () => import('./Views/Category/ViewDetails-category/viewDetails-category'),
    loading: Loading,
});

//Cashier
const Cashier = Loadable({
    loader: () => import('./Views/Cashier/viewCashier/viewCashier'),
    loading: Loading,
});
const AddCashier = Loadable({
    loader: () => import('./Views/Cashier/AddCashier/addCashier'),
    loading: Loading,
});
const EditCashier = Loadable({
    loader: () => import('./Views/Cashier/EditCashier/editCashier'),
    loading: Loading,
});
const ViewDetailsCashier = Loadable({
    loader: () => import('./Views/Cashier/ViewDetailsCashier/viewDetailsCashier'),
    loading: Loading,
});
// cinema Shows
const ViewShowsAdmin = Loadable({
    loader: () => import('./Views/ShowsCinema/ViewShow-admin/ViewShow'),
    loading: Loading,
});
const AddShowsAdmin = Loadable({
    loader: () => import('./Views/ShowsCinema/AddShow/AddShow/AddShow'),
    loading: Loading,
});
const EditCinemaShowsAdmin = Loadable({
    loader: () => import('./Views/ShowsCinema/EditShow/EditShow'),
    loading: Loading,
});
const SelectCinema = Loadable({
    loader: () => import('./Views/ShowsCinema/AddShow/SelectCinema'),
    loading: Loading,
});
const ViewDetailsShow = Loadable({
    loader: () => import('./Views/ShowsCinema/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading,
});

//Event Shows

const ViewShowsEventAdmin = Loadable({
    loader: () => import('./Views/ShowsEvent/ViewShow-admin/ViewShow'),
    loading: Loading,
});
const SelectEventOrganizer = Loadable({
    loader: () => import('./Views/ShowsEvent/AddShow/SelectOrganizer'),
    loading: Loading,
});
const AddEventShowsAdmin = Loadable({
    loader: () => import('./Views/ShowsEvent/AddShow/AddShow/AddShow'),
    loading: Loading,
});
const EditEventShowsAdmin = Loadable({
    loader: () => import('./Views/ShowsEvent/EditShow/EditShow'),
    loading: Loading,
});
const ViewDetailsShowEventAdmin = Loadable({
    loader: () => import('./Views/ShowsEvent/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading,
});

// Reservations
const ViewReservationEvent_admin = Loadable({
    loader: () => import('./Views/Reservations/Events/ViewReservations-event/ViewReservations'),
    loading: Loading,
});
const EventViewDetailsReservation = Loadable({
    loader: () => import('./Views/Reservations/Events/ViewDetailsReservation-event/ViewDetailsReservation'),
    loading: Loading,
});
const ViewReservationCinema_admin = Loadable({
    loader: () => import('./Views/Reservations/Cinema/ViewReservations-cinema/ViewReservations'),
    loading: Loading,
});
const CinemaViewDetailsReservation = Loadable({
    loader: () => import('./Views/Reservations/Cinema/ViewDetailsReservation-cinema/ViewDetailsReservation'),
    loading: Loading,
});

const ViewFreeReservation = Loadable({
    loader: () => import('./Views/Reservations/FreeReservation/ViewFreeReservation/ViewFreeReservation'),
    loading: Loading,
});
const ViewFreeReservationDetails = Loadable({
    loader: () => import('./Views/Reservations/FreeReservation/ViewDetailsFreeReservation/ViewDetailsFreeReservation'),
    loading: Loading,
});
const ViewTicketReservation = Loadable({
    loader: () => import('./Views/Reservations/TicketReservation/ViewTicketReservation/ViewTicketReservation'),
    loading: Loading,
});
const ViewTicketReservationDetails = Loadable({
    loader: () => import('./Views/Reservations/TicketReservation/ViewDetailsTicketReservation/ViewDetailsTicketReservation'),
    loading: Loading,
});
//country
const ViewCountry = Loadable({
    loader: () => import('./Views/Area/Country/ViewCountry/ViewCountry'),
    loading: Loading,
});
const AddCountry = Loadable({
    loader: () => import('./Views/Area/Country/AddCountry/AddCountry'),
    loading: Loading,
});

const EditCountry = Loadable({
    loader: () => import('./Views/Area/Country/EditCountry/EditCountry'),
    loading: Loading,
});
//city
const ViewCity = Loadable({
    loader: () => import('./Views/Area/City/ViewCity/ViewCity'),
    loading: Loading,
});
const AddCity = Loadable({
    loader: () => import('./Views/Area/City/AddCity/AddCity'),
    loading: Loading,
});

const EditCity = Loadable({
    loader: () => import('./Views/Area/City/EditCity/EditCity'),
    loading: Loading,
});

const ViewRegion = Loadable({
    loader: () => import('./Views/Area/Region/ViewRegion/ViewRegion'),
    loading: Loading,
});
const AddRegion = Loadable({
    loader: () => import('./Views/Area/Region/AddRegion/AddRegion'),
    loading: Loading,
});
const EditRegion = Loadable({
    loader: () => import('./Views/Area/Region/EditRegion/EditRegion'),
    loading: Loading,
});
const AboutUs = Loadable({
    loader: () => import('./Views/AppSettings/AboutUs/AboutUs'),
    loading: Loading,
});
const EditAboutUsAr = Loadable({
    loader: () => import('./Views/AppSettings/AboutUs/EditAboutUsAR/EditAboutUs'),
    loading: Loading,
});
const EditAboutUsEn = Loadable({
    loader: () => import('./Views/AppSettings/AboutUs/EditAboutUsEN/EditAboutUs'),
    loading: Loading,
});
const ReservationSteps = Loadable({
    loader: () => import('./Views/AppSettings/ReservationSteps/ViewReservationSteps'),
    loading: Loading,
});

// Chat
const PreviewChat = Loadable({
    loader: () => import('./Views/Chat/ViewConversations/ViewConv'),
    loading: Loading

})
const PreviewChatDetails = Loadable({
    loader: () => import('./Views/Chat/ViewDetailsConversation/ViewDetailsconv'),
    loading: Loading

})
// Advirtisments
const Advirtisment = Loadable({
    loader: () => import('./Views/Advirtisment/ViewAdvirtisment/ViewAdvirtisment'),
    loading: Loading

})
const AddAdvirtisment = Loadable({
    loader: () => import('./Views/Advirtisment/AddAdvirtisment/AddAdvirtisment'),
    loading: Loading

})
const EditAdvirtisment = Loadable({
    loader: () => import('./Views/Advirtisment/EditAdvirtisment/EditAdvirtisment'),
    loading: Loading
})
//TicketPrice
const ViewTicketPrice = Loadable({
    loader: () => import('./Views/TicketPrice/ViewTicketPrice/ViewTicketPrice'),
    loading: Loading

})
const AddTicketPrice = Loadable({
    loader: () => import('./Views/TicketPrice/AddTicketPrice/AddTicketPrice'),
    loading: Loading

})
const EditTicketPrice = Loadable({
    loader: () => import('./Views/TicketPrice/EditTicketPrice/EditTicketPrice'),
    loading: Loading
})
//OurShows
const ViewOurShows = Loadable({
    loader: () => import('./Views/OurShows/ViewShow/ViewShow'),
    loading: Loading
})
const AddOurShows = Loadable({
    loader: () => import('./Views/OurShows/AddShow/AddShow'),
    loading: Loading
})
const EditOurShows = Loadable({
    loader: () => import('./Views/OurShows/EditShow/EditShow'),
    loading: Loading
})
const OurShowsDetails = Loadable({
    loader: () => import('./Views/OurShows/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading
})


//OurShows
const ViewOurFreeShows = Loadable({
    loader: () => import('./Views/OurFreeShows/ViewShow/ViewShow'),
    loading: Loading
})
const AddOurFreeShows = Loadable({
    loader: () => import('./Views/OurFreeShows/AddShow/AddShow'),
    loading: Loading
})
const EditOurFreeShows = Loadable({
    loader: () => import('./Views/OurFreeShows/EditShow/EditShow'),
    loading: Loading
})
const OurShowsFreeDetails = Loadable({
    loader: () => import('./Views/OurFreeShows/ViewDetailsShow/ViewDetailsShow'),
    loading: Loading
})

const ViewHalls = Loadable({
    loader: () => import('./Views/ShowPlace/ViewShowPlace/ViewShowPlace'),
    loading: Loading
})
const AddHalls = Loadable({
    loader: () => import('./Views/ShowPlace/AddShowPlace/AddShowPlace'),
    loading: Loading
})
const EditHalls = Loadable({
    loader: () => import('./Views/ShowPlace/EditShowPlace/EditShowPlace'),
    loading: Loading
})
const HallsDetails = Loadable({
    loader: () => import('./Views/ShowPlace/ViewDetailsShowPlace/ViewDetailsShowPlace'),
    loading: Loading
})
const AddHallChairs = Loadable({
    loader: () => import('./Views/Chairs/AddChairs/AddChairs'),
    loading: Loading,
});
const EditHallChairs = Loadable({
    loader: () => import('./Views/Chairs/EditChairs/editOneChair'),
    loading: Loading,
});

const EditAllHallChairs = Loadable({
    loader: () => import('./Views/Chairs/EditChairs/EditChairs'),
    loading: Loading,
});

const AboutApp = Loadable({
    loader: () => import('./Views/AppSettings/AboutApp/AboutApp'),
    loading: Loading,
});
// PromoCode
const PromoCode = Loadable({
    loader: () => import('./Views/PromoCode/ViewPromoCode/viewpromo'),
    loading: Loading,
});
const PromoCodeViewDetails = Loadable({
    loader: () => import('./Views/PromoCode/PromoCodeViewDetails/PromoCodeViewDetails'),
    loading: Loading,
});
const AddPromoCode = Loadable({
    loader: () => import('./Views/PromoCode/AddPromoCode/addpromo'),
    loading: Loading,
});
const routes = [
    //PromoCode
    { path: `/MyTicket/promoCode`, exact: true, name: 'Promo Code', component: PromoCode },
    { path: `/MyTicketViewDetails-promoCode`, exact: true, name: 'Promo Code', component: PromoCodeViewDetails },
    { path: `/MyTicket/AddPromoCode`, exact: true, name: 'Promo Code', component: AddPromoCode },

    //Login page
    { path: '/MyTicket/admin-login', exact: true, name: 'Loginpage', component: Loginpage },
    // Dashboard
    { path: '/MyTicket/Dashboard', exact: true, name: 'Dashboard', component: Dashboard },

    { path: '/MyTicket/ShareDriverApp', exact: true, name: 'Share Driver App ', component: SharingDriverApp },
    { path: '/MyTicket/ShareClientApp', exact: true, name: 'Share Client App ', component: SharingClientApp },
    //AboutApp
    { path: '/MyTicket/AboutApp', exact: true, name: 'AboutApp', component: AboutApp },

    //Profile
    { path: '/MyTicket/profile', exact: true, name: 'Dashboard', component: Profile },

    //chairs
    { path: '/MyTicket/addChairs', exact: true, name: 'Add Chair ', component: AddHallChairs },
    { path: '/MyTicket/editChairs', exact: true, name: 'Edit Chair ', component: EditHallChairs },

    { path: '/MyTicket/editAllChairs', exact: true, name: 'Edit Chair ', component: EditAllHallChairs },

    //showplace
    { path: '/MyTicket/ViewHalls', exact: true, name: 'ViewHalls', component: ViewHalls },
    { path: '/MyTicket/AddHalls', exact: true, name: 'AddHalls', component: AddHalls },
    { path: '/MyTicket/EditHalls', exact: true, name: 'EditHalls', component: EditHalls },
    { path: '/MyTicket/HallsDetails', exact: true, name: 'HallsDetails', component: HallsDetails },

    //TicketPrice
    { path: '/MyTicket/ViewTicketPrice', exact: true, name: 'ViewTicketPrice', component: ViewTicketPrice },
    { path: '/MyTicket/AddTicketPrice', exact: true, name: 'AddTicketPrice', component: AddTicketPrice },
    { path: '/MyTicket/EditTicketPrice', exact: true, name: 'EditTicketPrice', component: EditTicketPrice },

    //OurShows
    { path: '/MyTicket/ViewOurShows', exact: true, name: 'ViewOurShows', component: ViewOurShows },
    { path: '/MyTicket/AddOurShows', exact: true, name: 'AddOurShows', component: AddOurShows },
    { path: '/MyTicket/EditOurShows', exact: true, name: 'EditOurShows', component: EditOurShows },
    { path: '/MyTicket/OurShowsDetails', exact: true, name: 'OurShowsDetails', component: OurShowsDetails },


    //OurShows
    { path: '/MyTicket/ViewOurFreeShows', exact: true, name: 'ViewOurFreeShows ', component: ViewOurFreeShows },
    { path: '/MyTicket/AddOurFreeShows', exact: true, name: 'AddOurFreeShows', component: AddOurFreeShows },
    { path: '/MyTicket/EditOurFreeShows', exact: true, name: 'EditOurFreeShows', component: EditOurFreeShows },
    { path: '/MyTicket/OurShowsFreeDetails', exact: true, name: 'OurShowsFreeDetails', component: OurShowsFreeDetails },

    //app settings
    { path: '/MyTicket/AboutUs', exact: true, name: 'AboutUs', component: AboutUs },
    { path: '/MyTicket/EditAboutUsAr', exact: true, name: 'EditAboutUsAr', component: EditAboutUsAr },
    { path: '/MyTicket/EditAboutUsEn', exact: true, name: 'EditAboutUsEn', component: EditAboutUsEn },
    { path: '/MyTicket/ReservationSteps', exact: true, name: 'ReservationSteps', component: ReservationSteps },

    //Country
    { path: '/MyTicket/ViewCountry', exact: true, name: 'Coutry', component: ViewCountry },
    { path: '/MyTicket/AddCountry', exact: true, name: 'Add Country ', component: AddCountry },
    { path: '/MyTicket/EditCountry', exact: true, name: 'Edit Country ', component: EditCountry },

    //City
    { path: '/MyTicket/ViewCity', exact: true, name: 'Coutry', component: ViewCity },
    { path: '/MyTicket/AddCity', exact: true, name: 'Add Country ', component: AddCity },
    { path: '/MyTicket/EditCity', exact: true, name: 'Edit Country ', component: EditCity },

    //Region
    { path: '/MyTicket/ViewRegion', exact: true, name: 'ViewRegion', component: ViewRegion },
    { path: '/MyTicket/AddRegion', exact: true, name: 'Add Region ', component: AddRegion },
    { path: '/MyTicket/EditRegion', exact: true, name: 'Edit Region ', component: EditRegion },


    //Clients
    { path: '/MyTicket/clients', exact: true, name: 'clients', component: Client },
    { path: '/MyTicket/AddClient', exact: true, name: 'Add Client ', component: AddClient },
    { path: '/MyTicket/EditClient', exact: true, name: 'Edit Client ', component: EditClient },
    { path: '/MyTicket/viewDetails-Client', exact: true, name: 'view Details Client ', component: ViewDetailsClient },
    // Event
    { path: '/MyTicket/Events', exact: true, name: 'Events', component: ViewEvents },
    { path: '/MyTicket/AddEvent', exact: true, name: 'Add Event ', component: AddEvent },
    { path: '/MyTicket/EditEvent', exact: true, name: 'Edit Event ', component: EditEvent },
    { path: '/MyTicket/viewDetails-Event', exact: true, name: 'View Details Event ', component: ViewDetailsEvent },

    // Cinema
    { path: '/MyTicket/cinemas', exact: true, name: 'cinemas', component: Cinema },
    { path: '/MyTicket/AddCinema', exact: true, name: 'Add Cinema ', component: AddCinema },
    { path: '/MyTicket/EditCinema', exact: true, name: 'Edit Cinema ', component: EditCinema },
    { path: '/MyTicket/viewDetails-Cinema', exact: true, name: 'view Details Film ', component: CinemaDetails },

    // Film
    { path: '/MyTicket/Films', exact: true, name: 'Films', component: Movies },
    { path: '/MyTicket/AddFilm', exact: true, name: 'Add Film ', component: AddFilm },
    { path: '/MyTicket/EditFilm', exact: true, name: 'Edit Film ', component: EditFilm },
    { path: '/MyTicket/viewDetails-Film-admin', exact: true, name: 'view Details Film admin ', component: ViewDetailsFilm_admin },

    // Film Type
    { path: '/MyTicket/filmTypes', exact: true, name: 'Film Types', component: Type },
    { path: '/MyTicket/AddFilmTypes', exact: true, name: 'Add Film Types', component: AddType },
    { path: '/MyTicket/EditFilmTypes', exact: true, name: 'Edit Film Types', component: EditType },
    { path: '/MyTicket/viewDetails-FilmType', exact: true, name: 'View Details Film Typs', component: ViewDetailsFilmTyps },

    //Sliders
    { path: '/MyTicket/sliders', exact: true, name: 'Slider', component: Slider },
    { path: '/MyTicket/Addslider', exact: true, name: 'Add Slider', component: AddSlider },
    { path: '/MyTicket/Editslider', exact: true, name: 'Edit Slider', component: EditSlider },
    //Sponsers
    { path: '/MyTicket/sponser', exact: true, name: 'Sponser', component: Sponser },
    { path: '/MyTicket/Addsponser', exact: true, name: 'Add Sponser', component: AddSponser },
    { path: '/MyTicket/Editsponser', exact: true, name: 'Edit Sponser', component: EditSponser },

    //ReportFilteration
    { path: '/MyTicket/ReportFilteration', exact: true, name: 'ReportFilteration', component: ReportFilteration },
    { path: '/MyTicket/Create-Report', exact: true, name: 'Report Creation', component: ReportCreation },
    //Sub Admin
    { path: '/MyTicket/subAdmin', exact: true, name: 'Sub Admin', component: SubAdmin },
    { path: '/MyTicket/AddSubAdmin', exact: true, name: 'Add Sub Admin', component: AddSubAdmin },
    { path: '/MyTicket/EditSubAdmin', exact: true, name: 'Edit Sub Admin', component: EditSubAdmin },
    { path: `/MyTicket/viewDetails-SubAdmin`, exact: true, name: 'ViewDetails Sub Admin', component: ViewDetailsSubAdmin },
    { path: '/MyTicket/SubAdminRoles', exact: true, name: 'Sub Admin Roles', component: SubAdminRoles },

    //Notification
    { path: '/MyTicket/notification', exact: true, name: 'Notification', component: Notification },
    { path: '/MyTicket/AddNotification', exact: true, name: 'Notification', component: AddNotification },
    { path: '/MyTicket/ViewDetails-notification', exact: true, name: 'Chat Preview', component: NotificationsViewDetails },

    //Category
    { path: '/MyTicket/Category', exact: true, name: 'View Category', component: ViewCategory },
    { path: '/MyTicket/AddCategory', exact: true, name: 'Add Category', component: AddCategory },
    { path: '/MyTicket/EditCategory', exact: true, name: 'Edit Category', component: EditCategory },
    { path: '/MyTicket/ViewDetailsCategory', exact: true, name: 'View Details Category', component: ViewDetailsCategory },


    //Cashier
    { path: '/MyTicket/ViewCashier', exact: true, name: 'View Cashier', component: Cashier },
    { path: '/MyTicket/AddCashier', exact: true, name: 'Add Cashier', component: AddCashier },
    { path: '/MyTicket/EditCashier', exact: true, name: 'Edit Cashier', component: EditCashier },
    { path: '/MyTicket/ViewDetailsCashier', exact: true, name: 'View Details Cashier', component: ViewDetailsCashier },


    //Cinema Shows
    { path: '/MyTicket/cinemaShows-admin', exact: true, name: 'ViewShowsAdmin', component: ViewShowsAdmin },
    { path: '/MyTicket/AddCinemaShows-admin', exact: true, name: 'AddShowsAdmin', component: AddShowsAdmin },
    { path: '/MyTicket/EditCinemaShowsAdmin', exact: true, name: 'EditCinemaShowsAdmin', component: EditCinemaShowsAdmin },
    { path: '/MyTicket/selectCinema-cinemaShows', exact: true, name: 'selectCinema', component: SelectCinema },
    { path: '/MyTicket/viewDetails-Show', exact: true, name: 'view Details Show ', component: ViewDetailsShow },

    //Event Shows
    { path: '/MyTicket/eventShows-admin', exact: true, name: 'ViewShowsEventAdmin', component: ViewShowsEventAdmin },
    { path: '/MyTicket/AddEventShows-admin', exact: true, name: 'AddEventShowsAdmin', component: AddEventShowsAdmin },
    { path: '/MyTicket/EditEventShowsAdmin', exact: true, name: 'EditEventShowsAdmin', component: EditEventShowsAdmin },
    { path: '/MyTicket/selectOrganizer-eventShows', exact: true, name: 'SelectEventOrganizer', component: SelectEventOrganizer },
    { path: '/MyTicket/viewDetails-ShowEventAdmin', exact: true, name: 'View Details show admin', component: ViewDetailsShowEventAdmin },

    // Reservations
    { path: '/MyTicket/ViewReservation-Event-admin', exact: true, name: 'View Tickets', component: ViewReservationEvent_admin },
    { path: '/MyTicket/ViewDetailsReservation-event', exact: true, name: 'View Details Event  Reservation ', component: EventViewDetailsReservation },

    { path: '/MyTicket/ViewReservation-cinema-admin', exact: true, name: 'View Tickets', component: ViewReservationCinema_admin },
    { path: '/MyTicket/ViewDetailsReservation-cinema', exact: true, name: 'View Details Cinema  Reservation ', component: CinemaViewDetailsReservation },
    //free reservation
    { path: '/MyTicket/ViewFreeReservation', exact: true, name: 'ViewFreeReservation ', component: ViewFreeReservation },
    { path: '/MyTicket/ViewFreeReservationDetails', exact: true, name: 'ViewFreeReservationDetails ', component: ViewFreeReservationDetails },

    //TicketReservation
    { path: '/MyTicket/ViewTicketReservation', exact: true, name: 'ViewTicketReservation ', component: ViewTicketReservation },
    { path: '/MyTicket/ViewTicketReservationDetails', exact: true, name: 'ViewTicketReservationDetails ', component: ViewTicketReservationDetails },

    // Preview Chat
    { path: `/MyTicket/PreviewChat`, exact: true, name: 'PreviewChat', component: PreviewChat },
    { path: `/MyTicket/PreviewChat-Details`, exact: true, name: 'PreviewChat Details', component: PreviewChatDetails },

    //Talent-type
    { path: '/MyTicket/Talent-type', exact: true, name: 'View Talent-type', component: ViewTalenttype },
    { path: '/MyTicket/AddTalent-type', exact: true, name: 'Add Talent-type', component: AddTalenttype },
    { path: '/MyTicket/EditTalent-type', exact: true, name: 'Edit Talent-type', component: EditTalenttype },
    { path: '/MyTicket/ViewDetailsTalent-type', exact: true, name: 'View Details Talent-type', component: ViewDetailsTalenttype },
    //talent order

    { path: '/MyTicket/ViewTalentOrder', exact: true, name: 'ViewTalentOrder', component: ViewTalentOrder },
    { path: '/MyTicket/ViewDetailsTalentOrder', exact: true, name: 'ViewDetailsTalentOrder', component: ViewDetailsTalentOrder },

    //Talent
    { path: '/MyTicket/Talents', exact: true, name: 'View Talents', component: Talents },
    { path: '/MyTicket/ViewDetailsTalent', exact: true, name: 'View Details Talent', component: ViewDetailsTalent },
    { path: '/MyTicket/AddTalent', exact: true, name: 'Add Talent', component: AddTalent },
    { path: '/MyTicket/EditTalent', exact: true, name: 'EditTalent', component: EditTalent },
    { path: '/MyTicket/ViewTalentWork', exact: true, name: 'ViewTalentWork', component: ViewTalentWork },
    { path: '/MyTicket/AddTalentWork', exact: true, name: 'AddTalentWork', component: AddTalentWork },
    { path: '/MyTicket/EditTalentWork', exact: true, name: 'EditTalentWork', component: EditTalentWork },

    //Talent-section
    { path: '/MyTicket/Talent-Section', exact: true, name: 'View Talent-Section', component: TalentSection },
    // Advirtisments
    { path: `/MyTicket/AppSetting/Advirtisments`, exact: true, name: 'Advirtisments', component: Advirtisment },
    { path: `/MyTicket/AppSetting/Add-Advirtisments`, exact: true, name: 'Advirtisments', component: AddAdvirtisment },
    { path: `/MyTicket/AppSetting/Edit-Advirtisments`, exact: true, name: 'Advirtisments', component: EditAdvirtisment },

    // Corporation
    { path: `/MyTicket/Corporation`, exact: true, name: 'Corporation', component: Corporation },
    { path: `/MyTicket/viewDetails-Corporation`, exact: true, name: 'Corporation Details', component: CorporationDetails },

    // TOURISTICAL_MONUMENTS
    { path: `/MyTicket/TOURISTICAL_MONUMENTS`, exact: true, name: 'TOURISTICAL_MONUMENTS', component: TOURISTICAL_MONUMENTS },
    { path: `/MyTicket/viewDetails-TOURISTICAL_MONUMENTS`, exact: true, name: 'TOURISTICAL_MONUMENTS Details', component: TOURISTICAL_MONUMENTSDetails },
    { path: `/MyTicket/AddTOURISTICAL_MONUMENTS`, exact: true, name: 'Add TOURISTICAL_MONUMENTS', component: AddTOURISTICAL_MONUMENTS },
    { path: `/MyTicket/EditTOURISTICAL_MONUMENTS`, exact: true, name: ' EditTOURISTICAL_MONUMENTS', component: EditTOURISTICAL_MONUMENTS },

    //ViewEntertainement
    { path: `/MyTicket/ViewEntertainement`, exact: true, name: 'ViewEntertainement', component: ViewEntertainement },
    { path: `/MyTicket/AddEntertainement`, exact: true, name: 'AddEntertainement', component: AddEntertainement },
    { path: `/MyTicket/EditEntertainement`, exact: true, name: 'EditEntertainement', component: EditEntertainement },
    { path: `/MyTicket/EntertainementDetails`, exact: true, name: 'EntertainementDetails', component: EntertainementDetails },

]

export default routes;